export default "__VITE_ASSET__Ctw4l1mv__"